import { t } from 'i18next';
import { TextField } from '../../2-component';
import { formatAmountValueCents } from '../../../util';
import { Box } from '../../1-primative';
import CAD from '../../../assets/images/country-flags/Canada.svg';
import USD from '../../../assets/images/country-flags/US.svg';
import { Currencies } from '../../../interfaces/transaction';

interface AmountFieldProps {
  amount: string,
  setAmount: (amount: string) => void,
  label?: string,
  onBlur?: any,
  error?: any,
  sx?: any,
  disabled?: boolean
  locked?: boolean
  infoTooltip?: string,
  errorText?: string;
  inputProps?: any;
  InputProps?: any;
  size?: any;
  fullWidth?: boolean;
  useFormatAmountValueCents?: boolean;
  testId?: string;
  decimalPlaces?: number,
  placeholder?: string;
  currency?: string;
}

export const AmountField = ({
  amount, setAmount, label, onBlur, error, sx, infoTooltip, disabled, locked,
  errorText, inputProps, InputProps, size, fullWidth = true, useFormatAmountValueCents = false, testId, decimalPlaces = 2, placeholder, currency,
}: AmountFieldProps) => {
  const parseValue = (value: unknown): any => {
    if (value === undefined || value === '') {
      return '';
    }

    return useFormatAmountValueCents ? formatAmountValueCents(Number(value)) : value;
  };

  const getCurrencyImage = () => {
    switch (currency) {
      case Currencies.CAD: return CAD;
      case Currencies.USD: return USD;
      default: return null;
    }
  };

  const currencyImage = getCurrencyImage();

  return (
    <TextField
      onChange={(e: any) => setAmount(e.target.value)}
      testId={testId ?? 'amount-field'}
      label={label ?? t('components:amount')}
      fullWidth={fullWidth}
      lockMessage={t('pageConfiguration:notEditableMessage')}
      disabled={disabled}
      locked={locked}
      value={parseValue(amount)}
      decimalPlaces={decimalPlaces}
      placeholder={placeholder ?? `0.${'0'.repeat(decimalPlaces)}`}
      type="dollar"
      leadingIcon='dollar'
      onBlur={onBlur}
      error={error}
      sx={sx}
      infoTooltip={infoTooltip}
      errorText={errorText}
      inputProps={inputProps}
      size={size}
      InputProps={currency ? {
        ...InputProps,
        startAdornment: (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {currencyImage && (
              <Box
                sx={{
                  height: '20px',
                  width: '20px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignContent: 'center',
                  borderRadius: 10,
                  overflow: 'hidden',
                }}
              >
                <img
                  alt={currency || 'currency'}
                  src={currencyImage}
                  style={{ objectFit: 'cover', height: '100%' }}
                />
              </Box>
            )}
            <span>$</span>
          </Box>
        ),
      } : InputProps}
    />
  );
};
